export default __webpack_public_path__ + "static/media/percy.608c2a9c.png";